import React from 'react';
import PropTypes from 'prop-types';
import ArenaIcon from 'components/arena/ArenaIcon';
import connect from 'react-redux/es/connect/connect';
import { toggleFavourite } from 'ducks/arena';

const ArenaFavouriteItem = (
    { itemId, number, favouriteItemList, toggleFavourite }, // eslint-disable-line
) => (
    <ArenaIcon
        iconName={favouriteItemList.includes(itemId) ? 'heart--filled' : 'heart'}
        number={number}
        onClick={toggleFavourite}
        className="icon--interactive"
    />
);

ArenaFavouriteItem.propTypes = {
    itemId: PropTypes.number.isRequired,
    number: PropTypes.number.isRequired,
    favouriteItemList: PropTypes.arrayOf(PropTypes.number).isRequired,
    toggleFavourite: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    favouriteItemList: state.favouriteItemList,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    toggleFavourite: () => dispatch(toggleFavourite(ownProps.itemId)),
});

const ArenaFavouriteItemConnected = connect(mapStateToProps, mapDispatchToProps)(ArenaFavouriteItem);

export default ArenaFavouriteItemConnected;



// WEBPACK FOOTER //
// ./src/components/arena/ArenaFavouriteIcon.js